import { render, staticRenderFns } from "./FormFamily.pug?vue&type=template&id=cf8ecba4&lang=pug&"
import script from "./FormFamily.vue?vue&type=script&lang=js&"
export * from "./FormFamily.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports